module.exports = __webpack_public_path__ + "img/ADJUSTMENT_APPLIED.png";